<template>
	<div id="page-signup">
		<div class="page">
			<Navbar />
			<section>
				<div class="container">
					<div class="row justify-content-center">
						<div class="col-lg-5 col-md-8 col-sm-10 signup-cont">
							<div>
								<h1>Create Account</h1>
								<h2>Quick and easy. Deploy live in minutes</h2>
							</div>
							<div v-if="!success" class="signup-inputs">
								<alert ref="alertError" type="danger" />
								<div class="d-flex">
									<p class="input-first">
										<label class="input-names" for="account-first-name">First Name</label>
										<input class="input-names" id="account-first-name" type="text" v-model="inputFirstName" />
									</p>
									<p class="input-last">
										<label class="input-names" for="account-last-name">Last Name</label>
										<input class="input-names" id="account-last-name" type="text" v-model="inputLastName" />
									</p>
								</div>
								<label for="account-email">Email Address</label>
								<input id="account-email" type="email" v-model="inputEmail" />
								<label for="account-password">Password</label>
								<input id="account-password" type="password" v-model="inputPassword" />
								<label for="account-password-confirm">Confirm Password</label>
								<input id="account-password-confirm" type="password" v-model="inputPasswordConfirm" />
								<button class="button-global" type="submit" v-on:click="submit()">Continue</button>
							</div>
							<div v-if="success">
								<br/>
								<p>We sent a link to <b>{{inputEmail}}</b> to complete your account registration. Click it to login.</p>
							</div>
						</div>
						<div class="col-lg-4 col-sm-10 benefits-cont">
							<img class="guardian-logo" src="@/assets/img/guardian.png" alt="Cosmic Guard" />
							<ul class="included-list">
								<li><span class="check free-span caps">free</span> {{this.trial}} day Trial</li>
								<li>Transparent Pay-As-Use Billing</li>
								<li>Premium Global Network
									<ul class="included-list mt-0">
										<li>Terabit-scale</li>
										<li>Optimized Latency</li>
										<li>Decreased Network Volatility</li>
									</ul>
								</li>
								<li>Cosmic Guard
									<ul class="included-list mt-0">
										<li>Unmetered Limit</li>
										<li>1s Mitigation Time</li>
										<li>1ms Mitigation Latency</li>
										<li>Layer 4 & 7 Protection</li>
										<li>99.9% DDoS SLA Guarantee</li>
									</ul>
								</li>
								
							</ul>
						</div>
					</div>
				</div>
			</section>
		</div>
		<Footer />
	</div>
</template>

<script lang="js">
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
	data() {
		return {
			trial: 7,
			promoId: "",
			success: false,
			inputFirstName: "",
			inputLastName: "",
			inputEmail: "",
			inputPassword: "",
			inputPasswordConfirm: "",
		}
	},
	methods: {
		submit: function() {
			if (this.inputFirstName.length == 0) {
				this.$refs.alertError.set("Please enter your first name.")
				return
			}
			if (this.inputLastName.length == 0) {
				this.$refs.alertError.set("Please enter your last name.")
				return
			}
			if (this.inputEmail.length == 0) {
				this.$refs.alertError.set("Please enter your email address.")
				return
			}
			if (this.inputPassword.length == 0) {
				this.$refs.alertError.set("Please enter your password.")
				return
			}
			if (this.inputPasswordConfirm.length == 0) {
				this.$refs.alertError.set("Please confirm your password.")
				return
			}
			if (this.inputPassword != this.inputPasswordConfirm) {
				this.$refs.alertError.set("Your passwords do not match! Please try again.")
				return
			}
			this.$recaptchaLoaded().then((recaptcha) => {
				this.$recaptcha('signup').then((token) => {
					let payload = new FormData()
					payload.append('firstname', this.inputFirstName)
					payload.append('lastname', this.inputLastName)
					payload.append('email', this.inputEmail)
					payload.append('password', this.inputPassword)
					payload.append('captcha', token)
					payload.append('promotion', this.promoId)
					this.$http.post('/api/portal/v1/flex/onboard', payload, {
						headers: {
							'Content-Type': 'multipart/form-data',
						}
					}).then((result) => {
						console.log("url: " + result.data)
						this.success = true
					}).catch((error) => {
						var response = error.response.data
						var responseError = response.error
						if (!responseError) {
							responseError = '';
						}
						var status = error.response.status
						var message = null
						if (status == 500) {
							message = "Internal server error. Please try again in a few moments."
						} else if (status == 401) {
							if (responseError == "captcha error") {
								message = "Captcha is not valid. Please try again."
							} else {
								message = "Unexpected request error. Please try again in a few moments."
							}
						} else if (status == 409) {
							message = "Email address is already in use."
						} else {
							message = "Unexpected error. Please try again in a few moments."
						}
						this.$refs.alertError.set(message)
					})
				}).catch((error) => {
					this.$refs.alertError.set("Captcha error: " + error)
				})
			});
		},
	},
	components: {
		Alert,
		Navbar,
		Footer
	},
	mounted() {
		if (this.$route.params.id !== undefined) {
			let promoId = this.$route.params.id;
			let promoSplit = promoId.split("_")
			if (promoSplit.length == 2 && btoa(promoSplit[1]) == 'MW10') {
				this.trial = 30
				this.promoId = promoId
				return
			} else if (promoSplit.length == 2 && btoa(promoSplit[1]) == 'MTRkdA==') {
				this.trial = 14
				this.promoId = promoId
				return
			}
		}
		this.trial = 7
	},
};
</script>

<style scoped>
#page-signup {
	background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(7, 13, 18, 255) 40%);
}

.benefits-cont, .signup-cont {
    margin: 4em auto 6em auto;
}
.benefits-cont {
    text-align: center;
}
.benefits-cont p, .benefits-cont ul {
    margin-left: 2em;
    text-align: left;
}
.guardian-logo {
	width: 15em;
	margin-bottom: -1em;
}

.signup-inputs {
	margin-top: 1em;
}
.signup-inputs input {
    width: 100%;
    line-height: 2em;

    border-radius: 5px;
    border: 1px solid #3e78d3;
    background-color: black;
}

form p {
    margin-bottom: 0px;
    float: left;
    width: 49%;
}
.signup-inputs input {
    padding-left: 0.5em;
    font-weight: 500;
    margin-bottom: 0.5em;

    text-transform: none;
}
.signup-inputs button {
	margin-top: 0.7em;
}
.input-first {
	margin-right: 2%;
}
.input-first, .input-last {
	margin-bottom: 0;
}

.included-list li:before { 
    content:''; 
    display:inline-block; 
    height:1em; 
    width:1em; 
    background-image:url('~@/assets/img/caret-up-solid.svg'); 
    background-size:contain; 
    background-repeat:no-repeat;
}

.included-list {
	margin-top: 1.5em;
    padding-left: 1em;
    list-style: none;
}
</style>
